import { Controller } from "@hotwired/stimulus";

// Applies a project's default task price without overwriting manual task pricing.
export default class extends Controller {
  static targets = ["project", "unitPrice", "hint", "labelCoefficient", "checkCoefficient", "acceptCoefficient"];

  static values = {
    prices: Object,
    billingUnits: Object,
    processCoefficients: Object,
    newRecord: Boolean,
  };

  connect() {
    this.inheritedUnitPrice = null;
    this.inheritedCoefficients = {};
    if (this.newRecordValue) {
      if (this.unitPriceTarget.value === "") {
        this.inheritPrice();
      } else {
        this.refreshHint();
      }
      this.inheritCoefficients();
    } else {
      this.refreshHint();
    }
  }

  inheritPrice() {
    const currentPrice = this.unitPriceTarget.value;
    if (currentPrice !== "" && currentPrice !== this.inheritedUnitPrice) {
      this.refreshHint();
      return;
    }

    const defaultPrice = this.defaultPrice();
    this.unitPriceTarget.value = defaultPrice || "";
    this.inheritedUnitPrice = defaultPrice || null;
    this.refreshHint();
  }

  inheritCoefficients() {
    Object.entries(this.defaultCoefficients() || {}).forEach(([processType, coefficient]) => {
      const target = this[`${processType}CoefficientTarget`];
      if (target.value !== "" && target.value !== this.inheritedCoefficients[processType]) return;

      target.value = coefficient || "";
      this.inheritedCoefficients[processType] = coefficient || null;
    });
  }

  markCoefficientAsManual(event) {
    const processType = event.target.dataset.markTaskPriceFormTarget.replace("Coefficient", "");
    if (event.target.value !== this.inheritedCoefficients[processType]) {
      this.inheritedCoefficients[processType] = null;
    }
  }

  markAsManual() {
    if (this.unitPriceTarget.value !== this.inheritedUnitPrice) {
      this.inheritedUnitPrice = null;
    }
  }

  refreshHint() {
    const defaultPrice = this.defaultPrice();
    const billingUnit = this.billingUnitsValue?.[this.projectTarget.value] || "项目计费单位";
    this.hintTarget.textContent = defaultPrice
      ? `默认 ¥${defaultPrice} / ${billingUnit}，可修改`
      : "项目未配置应结算单价，可单独填写";
  }

  defaultPrice() {
    return this.pricesValue?.[this.projectTarget.value];
  }

  defaultCoefficients() {
    return this.processCoefficientsValue?.[this.projectTarget.value];
  }
}
